import React from "react";
import Nav from "../components/crown/Nav";
import Hero from "../components/crown/Hero";
import CredibilityStrip from "../components/crown/CredibilityStrip";
import WhyChooseCrownLedger from "../components/crown/WhyChooseCrownLedger";
import How_it_works from "../components/crown/How_it_works";
import StatsSection1 from "../components/crown/StatsSection1";
import StatsSection2 from "../components/crown/StatsSection2";
import FAQSection from "../components/crown/FAQSection";
import BuiltFor from "../components/crown/BuiltFor";
import Mission from "../components/crown/Mission";
import Features, { IntegrationsSection } from "../components/crown/Features";
import Offer from "../components/crown/Offer";
import Calculator from "../components/crown/Calculator";
import Founder from "../components/crown/Founder";
import FounderQuote from "../components/crown/FounderQuote";
import Footer from "../components/crown/Footer";
import CredibilityStats from "../components/crown/CredibilityStats";
import AISystemSection from "../components/crown/AISystemSection";


export default function CrownLedger() {
  return (
    <div className="bg-void min-h-screen text-pri">
      <Nav />
      <main>
        <Hero />
        <CredibilityStrip />
        <BuiltFor />
        <Calculator />
        <StatsSection1 />
        <Features />
        <Offer /> 
        <How_it_works />
        <StatsSection2 />
        <Mission />
        <FAQSection />

  {/*     <div style={{ display: 'flex', flexDirection: 'column', gap: '18px', maxWidth: '1200px', margin: '0 auto', width: '100%', padding: '0 24px' }}>
          <StatsSection1 />
          <StatsSection2 />
        </div>
        <BuiltFor />
        <Mission />
        <ModernHowItWorks />
        <IntegrationsSection />
        <Features />
        <Offer />
        <Calculator />
        <FAQSection />
        <FounderQuote />
        <Founder />
        <CredibilityStats />
        <AISystemSection />  */}
      </main>
      <Footer />
    </div>
  );
}
